import { useTranslation } from 'react-i18next';
import InternetBankingIcon from 'assets/icons/ico-ib.svg?react';

import AirBankIcon from 'assets/psd2/AIRBANK.svg?react';
import CeskasBankIcon from 'assets/psd2/CSAS.svg?react';
import CreditasBankIcon from 'assets/psd2/CREDITAS.svg?react';
import CSOBBankIcon from 'assets/psd2/CSOB.svg?react';
import KBBankIcon from 'assets/psd2/KB.svg?react';
import MBankIcon from 'assets/psd2/MBANK.svg?react';
import MonetaBankIcon from 'assets/psd2/MONETA.svg?react';
import RaiffeisenBankIcon from 'assets/psd2/RAIFFEISEN.svg?react';
import s from './InternetBanking.module.scss';
import { Typography } from '../../../components';
import IntroModalContent from './IntroModalContent';

function InternetBankingModal() {
  const { t } = useTranslation('intro');
  return (
    <IntroModalContent
      heading={t('modal_internet_banking.heading')}
      iconComponent={<InternetBankingIcon />}
      points={[
        t('modal_internet_banking.point_1') as string,
        t('modal_internet_banking.point_2') as string,
        t('modal_internet_banking.point_3') as string,
        t('modal_internet_banking.point_4') as string,
      ]}
    >
      <Typography
        kind="h3"
        size="m"
        fontWeight={700}
        className={s['section-heading']}
      >
        {t('modal_internet_banking.supported_banks')}
      </Typography>

      <div className={s.grid}>
        <div className={s.item}>
          <CeskasBankIcon className={s.icon} />
        </div>
        <div className={s.item}>
          <CreditasBankIcon className={s.icon} />
        </div>
        <div className={s.item}>
          <MonetaBankIcon className={s.icon} />
        </div>
        <div className={s.item}>
          <RaiffeisenBankIcon className={s.icon} />
        </div>
        <div className={s.item}>
          <AirBankIcon className={s.icon} />
        </div>
        <div className={s.item}>
          <MBankIcon className={s.icon} />
        </div>
        <div className={s.item}>
          <CSOBBankIcon className={s.icon} />
        </div>
        <div className={s.item}>
          <KBBankIcon className={s.icon} />
        </div>
      </div>
    </IntroModalContent>
  );
}

export default InternetBankingModal;
